import axios from 'axios';

// Llamado directo: Debbie corre con un CrossOriginFilter (allowedOrigins:"*",
// ver Debbie.java) así que no hace falta proxear por el mismo origen.
export const DEBBIE_ENVIRONMENTS = {
    desa: 'https://desa-validate.certisur.com',
    homo: 'https://homo-validate.certisur.com',
    prod: 'https://validate.certisur.com',
};

export default {
    environments: DEBBIE_ENVIRONMENTS,
    validate({ environment, policyName, signatureType, signedText, signature, signedTextPack, algorithm, certificate }) {
        const baseURL = DEBBIE_ENVIRONMENTS[environment];
        const body = new URLSearchParams();
        body.append('signatureType', signatureType);
        body.append('signedText', signedText);
        body.append('signature', signature);
        if (signedTextPack) body.append('signedTextPack', signedTextPack);
        // Requeridos por DebbieServlet para signatureType=PKCS1 (no hay
        // envelope CMS del que extraer certificado/algoritmo, a diferencia
        // de CAdES/XAdES).
        if (algorithm) body.append('algorithm', algorithm);
        if (certificate) body.append('certificate', certificate);
        return axios.post(`${baseURL}/${policyName}`, body, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then(response => response.data);
    },
};
